module.exports = __webpack_public_path__ + "static/media/SportsWyse_white@3x.87734dd5.png";